import React, { Component } from "react";
import { Row, Col, Card, Button, Empty } from "antd";
import Category from "../../components/CategoriesCard";
import { connect } from "react-redux";
import { CatalogAction } from "../../store/actions";
import General_Info from "../../components/generalInfo";
import RMX from "../../assets/images/b-RMX-1.png";
import "./Styles.css";
import CoverImage from "../../components/coverImage";
import ProductCard from "../../components/productCard";
import LoaderGif from "../../assets/images/ie_loader.gif";

class StorePreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryName: "",
      productsState: [],
    };
  }

  abc = (key) => {
    const ab = this.props.products.filter((item) => {
      return item.category_id == key.id;
    });
    this.setState({
      productsState: ab,
    });
  };

  componentDidMount() {
    const { getCategories } = this.props;
    getCategories();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const filterCategories = (nextProps.categories || []).filter((item) => {
      return nextProps.products.some((v) => {
        return v.category.id == item.id;
      });
    });
    const filterPro = nextProps.products.filter((item) => {
      return item.category.id === filterCategories?.[0]?.id;
    });
    this.setState({
      productsState: filterPro,
      categoryName:filterCategories?.[0]?.name
    });
  }

  render() {
    const assets = JSON.parse(localStorage.getItem("assets"));
    

    if (this?.props?.location?.state?.fromCustom) {
      return <General_Info />;
    }
    const filterCategories = (this.props.categories || []).filter((item) => {
      return this.props.products.some((v) => {
        return v.category.id == item.id;
      });
    });

    console.log("product==>", this.props.onChangeStep);
    console.log("companyDetails==>", this.props.loader);
    return (
      <Row justify="center">
        <Col xl={24} lg={24} xs={24} sm={24} md={24}>
          <Row justify="start">
            <Col
              xl={12}
              lg={12}
              xs={24}
              sm={24}
              md={12}
              style={{
                padding: "15px",

                marginTop: "20px",
              }}
            >
              <img
                src={RMX}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  backgroundRepeat: "no-repeat",
                  top: "-20px",
                }}
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col
              xl={20}
              lg={20}
              xs={22}
              sm={22}
              md={22}
              style={{ marginBottom: "60px" }}
            >
              <CoverImage
                isShowEditCoverImage={true}
                isShowProfileIcon={true}
                isShowProfileName={true}
                userImage={assets?.logo?.original}
                CoverImage={assets?.cover?.original}
              />
            </Col>
          </Row>
          <Row justify="center">
            <Col
              xl={20}
              xs={22}
              sm={22}
              md={22}
              lg={20}
              style={{ marginBottom: "10px" }}
            >
              <Card>
                <Row>
                  <Col span={24}>
                    <h2 className="text-left catalog-heading">Store Preview</h2>
                  </Col>
                  <Col xl={6} lg={8} xs={24} sm={24} md={8}>
                    <Category
                      abc={this.abc}
                      categorey={filterCategories}
                      isImageTrue={true}
                      StorePreview
                      categoryName={this.state.categoryName}
                      {...this.props}
                    />
                  </Col>
                  <Col xl={18} lg={16} xs={24} sm={24} md={16}>
                    <Row>
                      {this.state.productsState.length || [] ? (
                        this.state.productsState.map((item) => {
                          return (
                            <Col xl={8} lg={8} md={6} xs={24} sm={24}>
                              <ProductCard fromRegister={true} data={item} />
                            </Col>
                          );
                        })
                      ) : (
                        <Col span={24}>
                          <Empty description={"Nothing to show right now."} />
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <Row justify="center">
            <Col xl={20} xs={22} sm={22} md={22} lg={20}>
              <Row justify="end">
                <Col
                  xl={10}
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  style={{
                    marginBottom: "20px",
                  }}
                >

                  {!this.props.loader ?
                    <>
                      <Button
                        style={{
                          backgroundColor: "#26a69a",
                          color: "#fff",
                          width: "50%",
                        }}
                        onClick={() => this.props.onChangePreview()}
                      >
                        <span style={{ display: "flex", justifyContent: "center" }}>
                          ADD MORE PRODUCTS
                        </span>
                      </Button>
                      <Button
                        style={{
                          backgroundColor: "#ff9800",
                          color: "#fff",
                          width: "50%",
                        }}
                        onClick={() =>
                          this.props.postProduct(
                            this.props.products,
                            () => this.props.onChangeStep(),
                            true
                          )
                        }
                      >
                        <span style={{ display: "flex", justifyContent: "center" }}>
                          CONTINUE
                        </span>
                      </Button>
                    </>
                    :
                    <Row justify="end" align="middle" className="text-left">
                      <Col className="text-left" xs={6} sm={6} md={10} lg={3} xl={3}>
                        <img src={LoaderGif} height={"40"} width={"40"} />
                      </Col>
                    </Row>
                  }
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    categories: store.CatalogReducer.categories,
    companyDetails: store.UserReducer.companyDetails,
    loader: store.CatalogReducer.loader,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCategories: (params) => dispatch(CatalogAction.getCategoriesReq(params)),
    // getCompanyDetails: () => dispatch(UserAction.getCompantDetailReq()),
    getProducts: (params, isTrue) =>
      dispatch(CatalogAction.getProductReq(params, isTrue)),
    updateShippingCost: (value, id) =>
      dispatch(CatalogAction.updateShipingCostReq(value, id)),
    getShippingCost: () => dispatch(CatalogAction.getShipingCostReq()),
    updateProduct: (value, id, active) =>
      dispatch(CatalogAction.updateProductReq(value, id, active)),
    postProduct: (payload, cb, isTrue) =>
      dispatch(CatalogAction.postProductReq(payload, cb, isTrue)),
    basemixdata: (params) =>
      dispatch(CatalogAction.getBasemixCategoriesReq(params)),
    getbasemixes: (params) => dispatch(CatalogAction.getBasemixesReq(params)),
    getadditives: (params) => dispatch(CatalogAction.getAdditivesReq(params)),
    getbasemixesCategories: (params) =>
      dispatch(CatalogAction.getBasemixesCategoriesReq(params)),
    getTemplate: (params) => dispatch(CatalogAction.getTemplateReq(params)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StorePreview);
